export default "__VITE_ASSET__d406be62__"